import 'project/polyfill'
import classNames from 'classnames'
import { generateSrcSet } from 'project/image-proxy-web'
import { NextPageWithLayout } from '../types/nextPageWithLayout'
import SeoContainer from 'components/util/containers/SeoContainer'
import { homeBreadcrumb } from 'components/util/containers/Breadcrumbs'
import Link from 'next/link'

const NotFoundPage: NextPageWithLayout = () => {
  return (
    <SeoContainer
      seoProps={{
        description: "The page you're looking for doesn't exist.",
        title: 'Page Not Found | Hoxton Mix',
      }}
      breadcrumb={homeBreadcrumb()}
    >
      <main
        className={classNames(
          'new-design d-flex flex-column vh-100 align-items-center',
        )}
      >
        <div
          className='text-center align-items-center lh-114 pt-16 pb-16'
          style={{
            maxWidth: 710,
          }}
        >
          <h1 className='fs-fluid-32-64 mb-3'>
            Sorry it's not you. <span className='color-pink2'>It's us.</span>
          </h1>
          <span className='fs-fluid-20-24 fw-semibold text-muted text-center'>
            We're experiencing a server problem, but our engineers are on the
            job and will have the Hoxton Mix website up and running shortly.
          </span>
          <img
            {...generateSrcSet('/images/new/robot-404.png', 427, 550)}
            alt='404'
            className='img-fluid'
            height={550}
            width={427}
            loading='eager'
            fetchPriority='high'
          />
          <h2 className='fs-fluid-32-40 mb-3 mt-n12'>Bad gateway</h2>
          <span className='fs-20 fw-semibold text-muted text-center'>
            The web server reported a bad gateway error.{' '}
            <Link className='text-decoration-none' href='/'>
              Back To Home Page
            </Link>
          </span>
        </div>
      </main>
    </SeoContainer>
  )
}

NotFoundPage.displayName = 'NotFoundPage'

NotFoundPage.getLayout = (page: React.ReactNode) => <>{page}</>

export default NotFoundPage
